import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {Exchange} from "../model/exchange.model";
import {retryAfterMillis} from "../shared/constants";

@Injectable({providedIn: 'root'})
export class ExchangeService {

  private exchanges: Exchange[] = [];

  constructor(private apiService: ApiService) {
    this.load();
  }

  load() {
    this.apiService.get('exchanges')
      .subscribe(response => {
        let exchanges: Exchange[] = [];
        for (const exchange of response) {
          exchanges.push({
            id: exchange.id,
            name: exchange.name,
            icon: exchange.name.toLowerCase()
          });
        }
        this.exchanges = exchanges;
      }, err => {
        this.apiService.error({}, err);
        setTimeout(() => this.load(), retryAfterMillis);
      });
  }

  getExchanges() {
    return this.exchanges;
  }
}
